var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapacitorjs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8626 54.1143L0.310594 93.7162L61.3062 154.895L0 216.385L39.4283 256.004L100.858 194.497L161.955 255.564L201.507 215.962L39.8626 54.1143Z",
    fill: "#53B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.517 154.896L100.859 194.498L161.956 255.566L201.508 215.964L140.517 154.896Z",
    fill: "#119EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.517 154.896L100.859 194.498L116.126 209.679L140.517 154.896Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.57 100.985L256.001 39.478L216.432 0L155.019 61.3836L93.9172 0.310993L54.3652 39.913L216.01 201.761L255.562 162.159L194.57 100.985Z",
    fill: "#53B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.361 100.987L155.019 61.3851L93.9172 0.3125L54.3652 39.9145L115.361 100.987Z",
    fill: "#119EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.359 100.986L155.018 61.3842L139.748 46.1982L115.359 100.986Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitorjs);
export default __webpack_public_path__ + "static/media/capacitorjs.8fb886a563606556b5508ef300c9b5d3.svg";
export { ForwardRef as ReactComponent };